import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb-common/interfaces/grid-layout.service";
import { DeleteCellComponent } from "@irb-common/components/grid/renderers/delete.cell.component";
import { DeleteHeaderComponent } from "@irb-common/components/grid/renderers/delete.header.component";
import { UtilityService } from "@irb-common/services/utility.service";
import { ComExternalAccountsComponent } from "./com-external-accounts.component";
import {DecimalPipe} from "@angular/common";


@Injectable({
    providedIn: "root"
})
export class ComExtAccountHoldingsGridLayoutService implements GridLayoutService<ComExternalAccountsComponent> {
    sizeFor: any;


    constructor(private util: UtilityService, private decimalPipe: DecimalPipe) {
        this.sizeFor = {
      "Symbol": 150,
      "SharePrice": 100,
      "Quantity":200
    };

    }

    getFrameworkComponents() {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent
        };
    }

    mapSharePrice(params : any)
    {
        // console.log(params);
        if(params.data.securityType.toUpperCase()==="EXTERNAL")
        {
            return this.formatPrice(params.data.extSharePrice);
        }
        else{
          return "n/a";
        }

    }

  

    getColumnDefs(parent: ComExternalAccountsComponent) {
        return [{
            headerName: "Delete All",
            headerComponent: "DeleteHeaderComponent",
            headerComponentParams: { 
                message: "Remove all Entries?", 
                proceed: parent.deleteAll.bind(parent),
                cancel: parent.cancelDelete.bind(parent)
            },
            cellRenderer : "DeleteCellComponent",
            cellRendererParams: { 
                message: "Remove this Entry?",
                proceed: parent.delete.bind(parent),
                cancel: parent.cancelDelete.bind(parent)
            },
            resizable: false,
            minWidth: 25,
            maxWidth: 25,
            width: 25,
            pinned: "left"
        },
        
                {
                    headerName: "Symbol",
                    field: "extSymbol",
                    minWidth: this.sizeFor.Symbol,
                    maxWidth: this.sizeFor.Symbol,
                    width: this.sizeFor.Symbol,
                    sort:"asc",
                },
                {
                    headerName: "Share Price",
                    field: "extSharePrice",
                    minWidth: this.sizeFor.SharePrice,
                    maxWidth: this.sizeFor.SharePrice,
                    width: this.sizeFor.SharePrice,
                    valueGetter: this.mapSharePrice.bind(this),
                    editable: (params: any) => (params.data.securityType.toUpperCase()==="EXTERNAL") ? true : false,
                    cellEditor: 'NumericEditorComponent',
                    cellEditorParams: {
                        validationFn: (value: any) => {
                            const invalidMessage = 'This value entered is not valid';
                            const rangeMessage = 'This value is out of range';
                            value = !value ? '0' : value;
                            const numValue = parseFloat(value);
                            if (!(numValue >= 0 && numValue <= 999999999)) {
                                return rangeMessage;
                            }
                            const arrayWithDecimal = numValue.toString().split(".");
                            if (arrayWithDecimal.length > 1 && arrayWithDecimal[1].length > 2) {
                                return invalidMessage;
                            }
                            return true;
                        },
                        tooltiptext: 'This value is out of range'
                    }
                },
                {
                    headerName: "Quantity",
                    field: "shareQty",
                    minWidth: this.sizeFor.Quantity,
                    maxWidth: this.sizeFor.Quantity,
                    width: this.sizeFor.Quantity,
                    valueGetter: this.formatQuantity.bind(this),
                    editable:(params: any) => (params.data.securityType.toUpperCase()==="EXTERNAL") ? true : false,
                    cellEditor: 'NumericEditorComponent',
                    cellEditorParams: {
                        validationFn: (value: any) => {
                            const invalidMessage = 'This value entered is not valid';
                            const rangeMessage = 'This value is out of range';
                            value = !value ? '0' : value;
                            const numValue = parseFloat(value);
                            if (!(numValue >= 0 && numValue <= 999999999999999)) {
                                return rangeMessage;
                            }
                            const arrayWithDecimal = numValue.toString().split(".");
                            if (arrayWithDecimal.length > 1 && arrayWithDecimal[1].length > 3) {
                                return invalidMessage;
                            }
                            return true;
                        },
                        tooltiptext: 'This value is out of range'
                    }
                }
               
    ];
    }
    formatQuantity(params: any) {
        let returnValue;
        if(params?.data?.shareQty) {
            let returnValue = params?.data?.shareQty;
            let parseValue = params?.data?.shareQty.toString().replaceAll('$','').replaceAll(',','').replaceAll('%','');
            let value = parseValue;
            let formattedValue = this.decimalPipe.transform(value,'1.3-3','en-US');
            returnValue = formattedValue;
            return returnValue;

        } else {
            return params?.data?.shareQty;
        }
    }
    formatPrice(externalSharePrice: any) {
        let returnValue;
        if(externalSharePrice) {
            let returnValue = externalSharePrice;
            let parseValue = externalSharePrice.toString().replaceAll('$','').replaceAll(',','').replaceAll('%','');
            let value = parseValue;
            let formattedValue = this.decimalPipe.transform(value,'1.2-2','en-US');
            returnValue = formattedValue;
            return returnValue;

        } else {
            return externalSharePrice;
        }
    }
}
